import * as React from "react";
import "./index.scss";

/* ─────────────────────────────────────────────────────────────────────────────
   Inline SVG decoration components
   All props:  className  →  receives the absolute-position CSS class
───────────────────────────────────────────────────────────────────────────── */

/* Rainbow fan — used twice; uid keeps clipPath IDs unique per instance */
const IconFan = ({ className, uid = "fan-a" }) => (
  <svg
    className={className}
    width="215"
    height="153"
    viewBox="0 0 215 153"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath={`url(#${uid})`} data-figma-skip-parse="true">
      <g transform="matrix(0.028 0.146 -0.143088 0.0274416 87.0185 39.6265)">
        <foreignObject
          x="-1121.18"
          y="-1121.18"
          width="2242.37"
          height="2242.37"
        >
          <div
            style={{
              background:
                "conic-gradient(from 90deg,rgba(158,181,182,1) 0deg,rgba(249,146,211,1) 21.983deg,rgba(214,4,193,1) 87.0094deg,rgba(156,234,239,1) 282.584deg,rgba(61,220,151,1) 336.429deg,rgba(158,181,182,1) 360deg)",
              height: "100%",
              width: "100%",
              opacity: 1,
            }}
          />
        </foreignObject>
      </g>
    </g>
    <defs>
      <clipPath id={uid}>
        <path d="M213.912 26.4829C213.975 26.2506 214.037 26.0182 214.037 26.0182L116.935 -1.69267e-05C116.873 0.232341 116.811 0.464699 116.811 0.464699C106.351 39.5016 65.4541 62.6625 25.4027 51.9308L3.93987e-05 146.735C93.6086 171.817 189.381 118.034 213.912 26.4829Z" />
      </clipPath>
    </defs>
  </svg>
);

/* Red starburst flower — top-center, half-visible above the fold */
const IconFlowerRed = ({ className }) => (
  <svg
    className={className}
    width="308"
    height="154"
    viewBox="0 0 308 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M184.736 132.303L195.852 101.051L225.812 115.291C253.543 128.474 282.495 99.5456 269.289 71.8154L255.049 41.857L286.303 30.7416C315.232 20.4569 315.232 -20.4569 286.303 -30.7416L255.049 -41.857L269.289 -71.8155C282.473 -99.5457 253.543 -128.47 225.812 -115.291L195.852 -101.051L184.736 -132.304C174.451 -161.232 133.54 -161.232 123.251 -132.304L112.148 -101.051L82.188 -115.291C54.461 -128.47 25.5311 -99.5457 38.711 -71.8155L52.9509 -41.857L21.6974 -30.7416C-7.23247 -20.4569 -7.23247 20.4569 21.6974 30.7416L52.9509 41.857L38.711 71.8154C25.5311 99.5456 54.461 128.496 82.188 115.291L112.148 101.051L123.264 132.303C133.54 161.232 174.456 161.232 184.736 132.303Z"
      fill="#FF4522"
    />
    <ellipse
      cx="35"
      cy="-18"
      rx="35"
      ry="36.5"
      transform="matrix(1 0 0 -1 119 37)"
      fill="#FAF7EF"
    />
  </svg>
);

/* Yellow star with face — exact SVG from Figma */
const IconStarYellow = ({ className }) => (
  <svg
    className={className}
    width="214"
    height="231"
    viewBox="0 0 214 231"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M83.7035 30.3685C83.8478 28.43 86.3261 27.7143 87.3494 29.3156L111.145 66.552C111.796 67.5699 113.201 67.7308 114.115 66.8919L146.051 37.5715C147.459 36.2788 149.623 37.4524 149.301 39.3343L141.612 84.3443C141.416 85.4924 142.202 86.5411 143.332 86.6388L185.674 90.2989C187.484 90.4554 188.07 92.8174 186.575 93.9284L151.6 119.911C150.667 120.605 150.472 121.937 151.174 122.826L178.707 157.676C179.858 159.133 178.527 161.316 176.708 160.955L135.454 152.766C134.273 152.532 133.13 153.429 133.039 154.662L129.7 199.754C129.557 201.693 127.079 202.41 126.055 200.808L102.241 163.56C101.59 162.542 100.184 162.382 99.2707 163.221L67.3543 192.551C65.9468 193.845 63.7822 192.672 64.1028 190.79L71.7743 145.767C71.9699 144.619 71.1835 143.571 70.0536 143.474L27.7308 139.825C25.9208 139.669 25.3336 137.307 26.8284 136.196L61.7865 110.201C62.7195 109.507 62.9141 108.175 62.2124 107.287L34.6969 72.4477C33.5464 70.9909 34.8766 68.8083 36.6952 69.1689L77.9328 77.3462C79.1128 77.5802 80.2556 76.6834 80.3473 75.4513L83.7035 30.3685Z"
      fill="#FFC73B"
    />
    <path
      d="M96.5 112C95.6716 112 94.9903 112.674 95.0936 113.496C95.4241 116.127 96.6199 118.59 98.5147 120.485C100.765 122.736 103.817 124 107 124C110.183 124 113.235 122.736 115.485 120.485C117.38 118.59 118.576 116.127 118.906 113.496C119.01 112.674 118.328 112 117.5 112C116.672 112 116.013 112.676 115.875 113.493C115.567 115.326 114.696 117.032 113.364 118.364C111.676 120.052 109.387 121 107 121C104.613 121 102.324 120.052 100.636 118.364C99.3043 117.032 98.4331 115.326 98.1247 113.493C97.9872 112.676 97.3284 112 96.5 112Z"
      fill="#400039"
    />
    <circle cx="88" cy="109" r="3" fill="#400039" />
    <circle cx="126" cy="109" r="3" fill="#400039" />
  </svg>
);

/* Teal blob character — center right */
const IconCharacterTeal = ({ className }) => (
  <svg
    className={className}
    width="361"
    height="327"
    viewBox="0 0 361 327"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M276.694 224.517L276.612 224.601V224.685C278.694 257.443 257.714 287.056 226.775 295.151L226.694 295.193C209.633 323.002 175.714 334.327 146 322.121C116.286 334.327 82.3673 323.002 65.3061 295.193L65.2245 295.151C34.2857 287.056 13.3061 257.443 15.3878 224.685V224.601L15.3061 224.517C-5.10204 199.267 -5.10204 162.692 15.3061 137.483L15.3878 137.4V137.316C13.3061 104.557 34.2857 74.9448 65.2245 66.8496L65.3061 66.8076C82.3673 38.9987 116.286 27.6738 146 39.8796C175.714 27.6738 209.633 38.9987 226.694 66.8076L226.775 66.8496C257.714 74.9448 278.694 104.557 276.612 137.316V137.4L276.694 137.483C297.102 162.692 297.102 199.267 276.694 224.517Z"
      fill="#9CEAEF"
    />
    <path
      d="M129.625 220C128.175 220 126.983 221.18 127.164 222.618C127.742 227.222 129.835 231.533 133.151 234.849C137.089 238.788 142.43 241 148 241C153.57 241 158.911 238.788 162.849 234.849C166.165 231.533 168.258 227.222 168.836 222.618C169.017 221.18 167.825 220 166.375 220C164.925 220 163.772 221.183 163.532 222.613C162.992 225.821 161.467 228.806 159.137 231.137C156.183 234.091 152.177 235.75 148 235.75C143.823 235.75 139.817 234.091 136.863 231.137C134.533 228.806 133.008 225.821 132.468 222.613C132.228 221.183 131.075 220 129.625 220Z"
      fill="#400039"
    />
    <circle cx="92" cy="176" r="48" fill="white" />
    <circle cx="92" cy="176" r="27" fill="#400039" />
    <circle cx="204" cy="176" r="48" fill="white" />
    <circle cx="204" cy="176" r="27" fill="#400039" />
    <path
      d="M360.97 33.867L361 106C349.504 106 340.569 100.594 333.647 93.704C324.163 84.27 312.606 84.27 303.123 93.704C296.2 100.594 287.266 106 275.77 106C264.273 106 255.339 100.594 248.416 93.704C238.933 84.27 227.376 84.27 217.892 93.704C210.97 100.594 202.035 106 190.539 106C167.303 106 154.831 84.376 148 72.451H148.03L148 0C159.496 0 168.431 5.406 175.353 12.296C184.837 21.73 196.394 21.73 205.877 12.296C212.8 5.406 221.734 0 233.23 0C244.727 0 253.661 5.406 260.584 12.296C270.067 21.73 281.624 21.73 291.108 12.296C298.03 5.406 306.965 0 318.461 0C341.758 0 354.108 21.942 360.939 33.867H360.97Z"
      fill="#3DDC97"
    />
  </svg>
);

/* Orange star with face — exact SVG from Figma (structure matches yellow) */
const IconStarOrange = ({ className }) => (
  <svg
    className={className}
    width="162"
    height="174"
    viewBox="0 0 162 174"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M57.7249 1.9347C57.8693 -0.00380406 60.3475 -0.719453 61.3708 0.881872L85.1665 38.1182C85.817 39.1361 87.2226 39.297 88.1362 38.4582L120.072 9.13769C121.48 7.84498 123.644 9.0186 123.323 10.9006L115.633 55.9105C115.437 57.0587 116.223 58.1074 117.353 58.205L159.695 61.8651C161.505 62.0216 162.092 64.3836 160.596 65.4946L125.622 91.4775C124.688 92.1712 124.493 93.5035 125.195 94.3923L152.728 129.242C153.879 130.699 152.549 132.882 150.73 132.521L109.475 124.333C108.295 124.098 107.151 124.996 107.06 126.228L103.722 171.32C103.578 173.259 101.1 173.976 100.076 172.375L76.2623 135.126C75.6115 134.108 74.2055 133.948 73.2921 134.787L41.3757 164.118C39.9682 165.411 37.8036 164.238 38.1243 162.356L45.7957 117.334C45.9913 116.185 45.2049 115.137 44.075 115.04L1.75226 111.391C-0.0577524 111.235 -0.644937 108.874 0.849873 107.762L35.8079 81.7668C36.7409 81.073 36.9356 79.7414 36.2338 78.8529L8.71833 44.0139C7.56781 42.5572 8.89807 40.3745 10.7166 40.7351L51.9542 48.9125C53.1343 49.1465 54.277 48.2497 54.3687 47.0175L57.7249 1.9347Z"
      fill="#FF4522"
    />
    <path
      d="M70.5214 83.5663C69.693 83.5663 69.0117 84.2405 69.115 85.0624C69.4456 87.6934 70.6413 90.1567 72.5361 92.0516C74.7866 94.302 77.8388 95.5663 81.0214 95.5663C84.204 95.5663 87.2563 94.302 89.5067 92.0516C91.4016 90.1567 92.5973 87.6934 92.9278 85.0624C93.0311 84.2405 92.3499 83.5663 91.5214 83.5663C90.693 83.5663 90.0342 84.2425 89.8967 85.0594C89.5884 86.8925 88.7171 88.5985 87.3854 89.9302C85.6976 91.6181 83.4084 92.5663 81.0214 92.5663C78.6345 92.5663 76.3453 91.6181 74.6575 89.9302C73.3258 88.5985 72.4545 86.8925 72.1461 85.0594C72.0087 84.2425 71.3498 83.5663 70.5214 83.5663Z"
      fill="#400039"
    />
    <circle cx="62.0214" cy="80.5663" r="3" fill="#400039" />
    <circle cx="100.021" cy="80.5663" r="3" fill="#400039" />
  </svg>
);

/* Pink starburst flower */
const IconFlowerPink = ({ className }) => (
  <svg
    className={className}
    width="308"
    height="308"
    viewBox="0 0 308 308"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M184.736 286.303L195.852 255.051L225.812 269.291C253.543 282.474 282.495 253.546 269.289 225.815L255.049 195.857L286.303 184.742C315.232 174.457 315.232 133.543 286.303 123.258L255.049 112.143L269.289 82.1845C282.473 54.4543 253.543 25.53 225.812 38.7093L195.852 52.9486L184.736 21.6965C174.451 -7.23221 133.54 -7.23221 123.251 21.6965L112.148 52.9486L82.188 38.7093C54.461 25.53 25.5311 54.4543 38.711 82.1845L52.9509 112.143L21.6974 123.258C-7.23247 133.543 -7.23247 174.457 21.6974 184.742L52.9509 195.857L38.711 225.815C25.5311 253.546 54.461 282.496 82.188 269.291L112.148 255.051L123.264 286.303C133.54 315.232 174.456 315.232 184.736 286.303Z"
      fill="#F992D3"
    />
    <ellipse
      cx="42"
      cy="-35"
      rx="35"
      ry="36.5"
      transform="matrix(1 0 0 -1 112 191)"
      fill="#D604C1"
    />
  </svg>
);

/* Small purple flower with green stem + leaf */
const IconFlowerPurple = ({ className }) => (
  <svg
    className={className}
    width="218"
    height="162"
    viewBox="0 0 218 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M124.982 119.809L125 162C118.253 162 113.01 158.838 108.948 154.808C103.382 149.29 96.5999 149.29 91.0344 154.808C86.9721 158.838 81.7287 162 74.9821 162C68.2355 162 62.9921 158.838 58.9298 154.808C53.3643 149.29 46.582 149.29 41.0165 154.808C36.9542 158.838 31.7108 162 24.9642 162C11.3278 162 4.00859 149.352 0 142.377H0.0178955L0 100C6.7466 100 11.99 103.162 16.0523 107.192C21.6178 112.71 28.4001 112.71 33.9656 107.192C38.0279 103.162 43.2713 100 50.0179 100C56.7645 100 62.0079 103.162 66.0702 107.192C71.6357 112.71 78.418 112.71 83.9835 107.192C88.0458 103.162 93.2892 100 100.036 100C113.708 100 120.956 112.834 124.964 119.809H124.982Z"
      fill="#3DDC97"
    />
    <path
      d="M153.167 150.588L159.013 134.15L174.771 141.64C189.357 148.574 204.585 133.358 197.639 118.773L190.149 103.016L206.588 97.1693C221.804 91.7598 221.804 70.2402 206.588 64.8307L190.149 58.9843L197.639 43.2269C204.574 28.6416 189.357 13.4281 174.771 20.3601L159.013 27.8496L153.167 11.4118C147.757 -3.80394 126.239 -3.80394 120.827 11.4118L114.987 27.8496L99.2288 20.3601C84.6451 13.4281 69.4287 28.6416 76.361 43.2269L83.8508 58.9843L67.4123 64.8307C52.1959 70.2402 52.1959 91.7598 67.4123 97.1693L83.8508 103.016L76.361 118.773C69.4287 133.358 84.6451 148.586 99.2288 141.64L114.987 134.15L120.833 150.588C126.239 165.804 147.759 165.804 153.167 150.588Z"
      fill="#D604C1"
    />
    <ellipse
      cx="18"
      cy="-18"
      rx="18"
      ry="19"
      transform="matrix(1 0 0 -1 119 100)"
      fill="#FFC73B"
    />
  </svg>
);

/* Green blob character — bottom, partially clipped */
const IconCharacterGreen = ({ className }) => (
  <svg
    width="292"
    className={className}
    height="144"
    viewBox="0 0 292 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M276.694 189.517L276.612 189.601V189.685C278.694 222.443 257.714 252.056 226.775 260.151L226.694 260.193C209.633 288.002 175.714 299.327 146 287.121C116.286 299.327 82.3673 288.002 65.3061 260.193L65.2245 260.151C34.2857 252.056 13.3061 222.443 15.3878 189.685V189.601L15.3061 189.517C-5.10204 164.267 -5.10204 127.691 15.3061 102.483L15.3878 102.399V102.315C13.3061 69.5569 34.2857 39.9444 65.2245 31.8492L65.3061 31.8073C82.3673 3.99837 116.286 -7.32653 146 4.87919C175.714 -7.32653 209.633 3.99837 226.694 31.8073L226.775 31.8492C257.714 39.9444 278.694 69.5569 276.612 102.315V102.399L276.694 102.483C297.102 127.691 297.102 164.267 276.694 189.517Z"
      fill="#3DDC97"
    />
    <path
      d="M134.875 124.5C133.839 124.5 132.987 125.343 133.125 126.369C133.55 129.525 135.04 132.478 137.393 134.753C140.206 137.472 144.022 139 148 139C151.978 139 155.794 137.472 158.607 134.753C160.96 132.478 162.45 129.525 162.875 126.369C163.013 125.343 162.161 124.5 161.125 124.5C160.089 124.5 159.267 125.346 159.083 126.365C158.689 128.556 157.604 130.595 155.955 132.189C153.845 134.229 150.984 135.375 148 135.375C145.016 135.375 142.155 134.229 140.045 132.189C138.396 130.595 137.311 128.556 136.917 126.365C136.733 125.346 135.911 124.5 134.875 124.5Z"
      fill="#400039"
    />
    <circle cx="108.5" cy="93.4995" r="33.5" fill="white" />
    <ellipse cx="109" cy="93.4995" rx="19" ry="18.5" fill="#400039" />
    <circle cx="187.5" cy="93.4995" r="33.5" fill="white" />
    <ellipse cx="187" cy="93.4995" rx="19" ry="18.5" fill="#400039" />
  </svg>
);

/* ─────────────────────────────────────────────────────────────────────────────
   Contact section
───────────────────────────────────────────────────────────────────────────── */
const Contact = ({ title }) => (
  <section className="contact">
    <div className="contact-decor">
      <IconFan className="deco -top-left" uid="fan-top-left" />
      <IconFlowerRed className="deco -top-center" />
      <IconStarYellow className="deco -top-right" />
      <IconCharacterTeal className="deco -character-main" />
      <IconStarOrange className="deco -star-main" />
      <IconFlowerPink className="deco -bottom-left" />
      <IconFan className="deco -bottom-center" uid="fan-bottom-center" />
      <IconFlowerPurple className="deco -bottom-right" />
      <IconCharacterGreen className="deco -character-bottom" />
    </div>

    <div className="contact-content" data-scroll>
      <h2 className="title">{title || `Don't be shy, say hi!`}</h2>
      <p className="description">
        You can contact me through e-mail or my social media below:
      </p>
      <div className="actions">
        <a
          href="mailto:gabrielasbiscaro@gmail.com"
          className="pill"
          target="_blank"
          rel="noreferrer"
        >
          gabrielasbiscaro@gmail.com
        </a>
        <a
          href="https://www.instagram.com/gabiscaroo_/"
          className="pill"
          target="_blank"
          rel="noreferrer"
        >
          Instagram
        </a>
        <a
          href="https://www.linkedin.com/in/gabriela-bisc%C3%A1ro-4b90a78a/"
          className="pill"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
